import { pushPromoView, pushPromoClick } from "./utils";
import { KAHandlePromoEvents } from "../kevel/audience";
const PROMO_VIEW = "promoView";
const PROMO_CLICK = "promoClick";

/**
 * Push page custom advertising
 */
const pushPageCustomAdvertising = (data, eventName) => {
    const advertisingImpression = Object.assign({}, {
        "advertiserId": data.idAdvertised,
        "flightId": data.flightId,
        "campaignId": data.campaignId,
        "creative": data.imgAdvertised,
        "priorityId": data.priorityId,
        "adid": data.adid
    });

    if (PROMO_VIEW == eventName) {
        pushPromoView([advertisingImpression], PROMO_VIEW);
    } else if (PROMO_CLICK == eventName) {
        pushPromoClick([advertisingImpression], PROMO_CLICK);
        KAHandlePromoEvents([advertisingImpression], { event: PROMO_CLICK});
    }
};

module.exports = {
    pushPageCustomAdvertising: pushPageCustomAdvertising
};
